import { SetGetReplenishmentReport } from './thunk/setGetReplenishmentReport'

export const Thunks = {
    SetGetReplenishmentReport
}